import React from 'react'
import { BsArrowLeft } from "react-icons/bs"
import useAppContext from '../../hook/useAppContext'
import RelationCard from './RelationCard'
import './relation.css'

const Relation = () => {

      const {user, showRelation, setShowRelation} = useAppContext()
      const {relation} = user 

      const type = relation.code ? "" : relation.relation_type 

      const handleClickRelation = () => {
            setShowRelation(!showRelation)
      }

      return (
            <div className={showRelation ? "relation_wrapper active" : "relation_wrapper"}>
                  <div className="relation_header flex">
                        <button className="btn_relation__close flex" onClick={() => handleClickRelation()}>
                              <BsArrowLeft />
                        </button>
                        <h2>{type}</h2>
                  </div>
                  <RelationCard relation={relation} />
            </div>
      )
}

export default Relation
